import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 新增/编辑
 * @param params
 * @return {*}
 */
export function apiEdit (params) {
  return doHttp('/entrust/company/edit.action', HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = {
    id
  }
  return doHttp('/entrust/company/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = {
    id
  }
  return doHttp('/entrust/company/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 列表
 * @param {*} params
 * @param {*} pageIndex
 * @param {*} pageSize
 * @return {*}
 */
export function apiList (params, pageIndex = 1, pageSize = 20) {
  return doHttp(`/entrust/company/list.action?pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 新增委托公司许可证
 * @param {*} companyId
 * @param {*} number
 * @return {*}
 */
export function apiEntrustLicenseAdd (companyId, number) {
  let params = {
    companyId,
    number
  }
  return doHttp('entrust/company/license/add.action', HTTP_TYPE_GET, params)
}
